import React from 'react';
import {
  DateRangeDropdownV2,
  DocumentNumberRangeFieldV2,
  FormFieldV2 as FormField,
  SearchFieldV2 as SearchField
} from '@/components/custom/erp';
import { UseSearchFieldReturn } from '../../hooks/useSearchField';
import { khachHangSearchColumns, QUERY_KEYS } from '@/constants';
import { Label } from '@/components/ui/label';
import { KhachHang } from '@/types/schemas';

interface BasicInfoTabProps {
  formMode: 'add' | 'edit' | 'view';
  searchFieldStates?: UseSearchFieldReturn;
}

const BasicInfoTab = ({ formMode, searchFieldStates }: BasicInfoTabProps) => {
  return (
    <div className='space-y-3 p-4'>
      {/* Ngày c/từ (từ/đến) */}
      <div className='flex items-center gap-3'>
        <Label className='w-[150px] shrink-0 text-[13px]'>Ngày c/từ (từ/đến)</Label>
        <DateRangeDropdownV2
          fromDateName='ngay_ct1'
          toDateName='ngay_ct2'
          fromFieldClassName='w-[175px]'
          toFieldClassName='w-[175px]'
        />
      </div>

      {/* Số c/từ (từ/đến) */}
      <DocumentNumberRangeFieldV2 label='Số c/từ (từ/đến)' fromName='so_ct1' toName='so_ct2' />

      {/* Loại hóa đơn */}
      <div className='flex items-center gap-3'>
        <Label className='w-[150px] shrink-0 text-[13px]'>Loại nhập</Label>
        <FormField
          name='ma_ngv'
          type='select'
          className='w-[200px]'
          label=''
          options={[
            { value: 'ALL', label: 'Tất cả' },
            { value: '3', label: '3. Cả hai' },
            { value: '1', label: '1. Nhập sổ sách' },
            { value: '2', label: '2. Nhập thực tế' }
          ]}
          disabled={formMode === 'view'}
        />
      </div>

      <div className='flex items-center gap-3'>
        <Label className='w-[150px] shrink-0 text-[13px]'>Giao dịch</Label>
        <FormField
          name='ma_gd'
          type='select'
          className='w-[200px]'
          label=''
          options={[
            { value: 'ALL', label: 'Tất cả' },
            { value: 'NB', label: 'NB. Nhập nội bộ' },
            { value: 'DC', label: 'DC. Điều chỉnh' },
            { value: 'NK', label: 'DH. Nhập khác' },
            { value: 'TP', label: 'TP. Nhập thành phẩm' }
          ]}
          disabled={formMode === 'view'}
        />
      </div>

      {/* Mã khách hàng */}
      <div className='flex items-center gap-3'>
        <Label className='w-[150px] shrink-0 text-[13px]'>Mã đối tượng</Label>
        <SearchField<KhachHang>
          name='ma_kh'
          searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}/`}
          searchColumns={khachHangSearchColumns}
          columnDisplay='customer_code'
          displayRelatedField='customer_name'
          dialogTitle='Danh mục đối tượng'
          value={searchFieldStates?.state.khachHang?.customer_code}
          relatedFieldValue={searchFieldStates?.state.khachHang?.customer_name}
          onRowSelection={searchFieldStates?.actions.setKhachHang}
        />
      </div>

      {/* Diễn giải */}
      <div className='flex items-center gap-3'>
        <Label className='w-[150px] shrink-0 text-[13px]'>Diễn giải</Label>
        <div className='w-full'>
          <FormField name='dien_giai' type='text' disabled={formMode === 'view'} />
        </div>
      </div>
    </div>
  );
};

export default BasicInfoTab;
